import { SettingsPageContent } from './components/settings-page-content/settings-page-content';
import { SettingsPageHeader } from './components/settings-page-header/settings-page-header';

import type { SettingsPageHeaderMessages } from './components/settings-page-header/settings-page-header';
import type React from 'react';

type SettingsPageWrapperProps = {
  children: React.ReactNode;
  className?: string;
  messages: SettingsPageHeaderMessages;
  descriptionContent?: React.ReactNode;
  isTabbed?: boolean;
};

export const SettingsPageWrapper = ({
  children,
  className,
  messages,
  descriptionContent = null,
  isTabbed = false,
}: SettingsPageWrapperProps) => {
  return (
    <SettingsPageContent className={className} variant={isTabbed ? 'tabbed-content' : 'content'}>
      <SettingsPageHeader descriptionContent={descriptionContent} isTabbed={isTabbed} messages={messages} />
      {children}
    </SettingsPageContent>
  );
};
